/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface VoteResult
 */
export interface VoteResult {
  /**
   *
   * @type {string}
   * @memberof VoteResult
   */
  vimeoLink?: string | null;
  /**
   *
   * @type {string}
   * @memberof VoteResult
   */
  vimeoName: string;
  /**
   *
   * @type {number}
   * @memberof VoteResult
   */
  numberOfVotes?: number;
  /**
   *
   * @type {number}
   * @memberof VoteResult
   */
  firstPosition?: number;
  /**
   *
   * @type {number}
   * @memberof VoteResult
   */
  secondPosition?: number;
  /**
   *
   * @type {number}
   * @memberof VoteResult
   */
  thirdPosition?: number;
  /**
   *
   * @type {number}
   * @memberof VoteResult
   */
  points?: number;
}

export function VoteResultFromJSON(json: any): VoteResult {
  return VoteResultFromJSONTyped(json, false);
}

export function VoteResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoteResult {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    vimeoLink: !exists(json, "vimeoLink") ? undefined : json["vimeoLink"],
    vimeoName: json["vimeoName"],
    numberOfVotes: !exists(json, "numberOfVotes")
      ? undefined
      : json["numberOfVotes"],
    firstPosition: !exists(json, "firstPosition")
      ? undefined
      : json["firstPosition"],
    secondPosition: !exists(json, "secondPosition")
      ? undefined
      : json["secondPosition"],
    thirdPosition: !exists(json, "thirdPosition")
      ? undefined
      : json["thirdPosition"],
    points: !exists(json, "points") ? undefined : json["points"],
  };
}

export function VoteResultToJSON(value?: VoteResult | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    vimeoLink: value.vimeoLink,
    vimeoName: value.vimeoName,
    numberOfVotes: value.numberOfVotes,
    firstPosition: value.firstPosition,
    secondPosition: value.secondPosition,
    thirdPosition: value.thirdPosition,
    points: value.points,
  };
}
